
import * as CryptoJS from 'crypto-js';
import keys from '../config/storageKey';
import Hashids from 'hashids';
import helper from '../util/helper';

class Hasher {

    constructor(key) {
        this.hashids = new Hashids(keys.hash_key, 15);
        this.key = this.hashids.encode(key);
    }
    /**
     * Method used to transform a fetched collection.
     *
     * @param items The items to be transformed.
     *
     * @returns {Array} The transformed items.
     */
    setItem(key, item) {

      let old = localStorage.getItem(this.key);

      try{
        if(old && helper.isJson(old)){
          old = JSON.parse(old);
        }
        else{
          old = {};
        }
      }catch(e){
        old = {};
      }
      item = this.encrypt(item);

      if(old){
        old[key] = item;
        localStorage.setItem(this.key, JSON.stringify(old));
      }
      else{
        console.error('fail to set data', key, item);
      }
    }
  
    /**
     * Method used to transform a collection to be send.
     *
     * @param items The items to be transformed.
     *
     * @returns {Array} The transformed items.
     */
    getItem(key) {
      try{
        let old = localStorage.getItem(this.key) ? JSON.parse(localStorage.getItem(this.key)): {} ;
        return old ? old[key] ? this.decrypt(old[key]): '' : '';
      }catch(e){
        console.error('can\'t get data', key);
        console.log(e);
      }
      return undefined;
    }

    removeItem(key) {
      let old = JSON.parse(localStorage.getItem(this.key));
      old ? old[key] ? delete old[key]: false : false;
      localStorage.setItem(this.key, JSON.stringify(old));
    }

    encrypt(text) {
      return CryptoJS.AES.encrypt( JSON.stringify(text), keys.encrypt_key).toString();
    }

    decrypt(key){
      if(key){
        let bytes = CryptoJS.AES.decrypt(key, keys.encrypt_key);
        return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
      }
    }
  }


  export default (new Hasher(keys.encrypt_key));
